import { FunctionalComponent } from 'preact';
import { Suspense, lazy } from 'preact/compat';
import { useEffect, useState } from 'preact/hooks';
import { useDispatch, useSelector } from 'react-redux';

// import { trackAmplitudeEvent } from '../../../../shared/analytics';
import {
  selectOnboardingStep,
  shownOnboardingStep,
  hideOnboardingStep,
  // setTopSitesViewed,
} from '../slice';

const PopoverOnboarding = lazy(() => import('./PopoverOnboarding'));

const Onboarding: FunctionalComponent = () => {
  const dispatch = useDispatch();

  const nextStep = useSelector(selectOnboardingStep);
  const [shownStep, setShownStep] = useState(null);

  useEffect(() => {
    setShownStep(nextStep || null);
  }, [nextStep]);

  useEffect(() => {
    if (shownStep) {
      dispatch(shownOnboardingStep({ step: shownStep }));
    }
  }, [shownStep]);

  const handleClickNext = (): void => {
    // const eventName = {
    //   shells: 'Onboarding_clicked_shells_onboarding_message',
    //   counter: 'Onboarding_clicked_bottle_onboarding_message',
    //   topSites: 'Onboarding_clicked_sponsored_links_onboarding_message',
    //   customizeBg: 'Onboarding_clicked_customize_onboarding_message',
    //   searchForm: 'Onboarding_clicked_search_form',
    // }[shownStep];
    // if (eventName) {
    //   trackAmplitudeEvent(eventName, { category: 'Onboarding' });
    // }
    dispatch(hideOnboardingStep({ step: shownStep }));

    if (nextStep === 'searchForm') {
      document.getElementById('searchInput')?.focus();
    }
  };

  return shownStep ? (
    <Suspense fallback={null}>
      <PopoverOnboarding onClick={handleClickNext} nextStep={shownStep} />
    </Suspense>
  ) : null;
};

export default Onboarding;
